import { render, staticRenderFns } from "./ModalConfirmacao.vue?vue&type=template&id=07ffe72f"
import script from "./ModalConfirmacao.vue?vue&type=script&lang=js"
export * from "./ModalConfirmacao.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmacao.vue?vue&type=style&index=0&id=07ffe72f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports